import React from 'react'
import { TextInput } from 'react-admin'
import { CreateGuesser } from 'theme/components'

export const FreshdeskSubjectCreate = (props) => (
  <CreateGuesser {...props} variant="outlined" redirect="list">
    <TextInput source="name" />
    <TextInput source="translationKey" />
  </CreateGuesser>
)
